import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as flashActions from 'redux-flash'
import {
  CommunityBackgroundImage,
  CommunityImage,
  FlashMessageContainer,
  MultipleLogoBlock,
} from 'components'
import { updateDocumentTitle, useCommunity, useCommunityText } from 'utils'
import classnames from 'classnames'

const propTypes = {
  children: PropTypes.node,
  flashMessages: PropTypes.arrayOf(flashActions.flashMessageType),
  location: PropTypes.shape({ pathname: PropTypes.string }),
}

const defaultProps = {
  children: null,
  flashMessages: [],
  location: null,
}

function LayoutUnauthorized({ children, flashMessages, location }) {
  const community = useCommunity()
  const t = useCommunityText()
  const isApplicationPage = location?.pathname?.includes('/application')
  const tagline = isApplicationPage
    ? t('application.tagline') || t('tagline')
    : t('tagline')
  const {
    communityLogo,
    secondaryFooterLogo,
    secondarySideBySideLogo,
    thirdSideBySideLogo,
    secondSubLogo,
    loginBackgroundImg,
    footerLogos,
  } = community.defaultBranding

  const isSacramento = community.subdomain === 'sacramento'

  return (
    <div>
      <main className="authentication">
        <div className="image-block">
          <CommunityBackgroundImage
            className="image-block-inner"
            image={loginBackgroundImg}
          >
            <div
              className={classnames('logo-block', {
                'side-by-side': secondarySideBySideLogo,
              })}
            >
              <CommunityImage className="primary-logo" image={communityLogo} />
              {!isSacramento && secondarySideBySideLogo && (
                <div className="second-logo">
                  <CommunityImage image={secondarySideBySideLogo} />
                </div>
              )}

              {thirdSideBySideLogo && !secondSubLogo && (
                <div className="third-logo">
                  <CommunityImage image={thirdSideBySideLogo} />
                </div>
              )}
            </div>
            <span className="visually-hidden">
              {community.name || community.subdomain || 'Community'}
            </span>
            <h1>{tagline}</h1>
            <div className="logo-block page-bottom">
              {secondaryFooterLogo && (
                <CommunityImage image={secondaryFooterLogo} />
              )}
              {secondSubLogo && <CommunityImage image={secondSubLogo} />}
              {footerLogos && (
                <MultipleLogoBlock
                  logos={footerLogos}
                  className="footer-logos"
                />
              )}
            </div>
          </CommunityBackgroundImage>
        </div>
        <FlashMessageContainer
          className="unauthorized"
          messages={flashMessages}
        />
        {children}
      </main>
      <footer>
        {footerLogos && <MultipleLogoBlock logos={footerLogos} />}
      </footer>
    </div>
  )
}

LayoutUnauthorized.propTypes = propTypes
LayoutUnauthorized.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    flashMessages: flashActions.getFlashMessages(state),
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, null),
  updateDocumentTitle('Arts Partner | artlook')
)(LayoutUnauthorized)
